<template>
  <div class="flex flex-wrap uploadGoogleImg">
    <el-upload
      v-bind="defaultParams"
      :file-list="imageList"
      :on-change="onChange"
      :auto-upload="false"
      list-type="picture-card"
      ref="upload"
      class="mr-2 mb-4"
      v-show="imageList.length < defaultParams.limit"
    >
      <div class="leading-4 text-xs border w-full h-full flex flex-col justify-center items-center rounded-md p-4">
        <div class="mb-2">
          <el-button
            type="primary"
            size="medium"
            @click.stop="openLibrary"
            >素材库选择</el-button
          >
        </div>
        <el-button
          type="primary"
          size="medium"
          @click.stop="openDragUpload"
          >点击上传</el-button
        >
        <div class="text-gray-700 leading-6 mt-1">
          <div>横向图片：1.91:1</div>
          <div>方形图片：1:1</div>
          <div>纵向图片：4:5</div>
          <div>格式为PNG或JPEG</div>
        </div>
      </div>
    </el-upload>

    <div
      v-for="(file, index) in imageList"
      :key="file.uid"
      class="mr-4 mb-4 w-[160px] h-[240px] border-[1px] box-border border-dashed divide-inherit border-[#f2f2f2]"
    >
      <div class="relative w-full h-full leading-none box-border">
        <RetryImage
          :src="file.url"
          image-class="w-full h-full block"
          fit="contain"
          :max-retry="3"
          :retry-delay="1500"
        />
        <div
          class="w-full"
          v-if="file.status == 'uploading'"
        >
          <el-progress
            :stroke-width="10"
            :percentage="file.process"
          ></el-progress>
        </div>
        <!-- 删除 -->
        <div
          class="absolute -right-2 -top-2 w-6 h-6 leading-none cursor-pointer z-20"
          v-if="!disabled"
        >
          <i
            class="el-icon-circle-close hover:text-primary text-[24px]"
            @click.stop="deleteItem(index)"
          ></i>
        </div>
        <!-- 重新上传 -->
        <div
          class="z-10 absolute left-0 top-0 w-full h-full bg-white bg-opacity-75 bottom-0 right-0 m-auto flex flex-col justify-center items-center"
          v-if="file.status == 'fail'"
        >
          <div class="text-red-600 mt-3 text-base">
            <i class="el-icon-warning !text-red-600 !text-base"></i> 上传失败
          </div>
          <el-button
            size="mini"
            type="primary"
            @click.stop="uploadFile(file)"
            >重新上传</el-button
          >
        </div>
      </div>
    </div>
    <!-- 个人素材库 -->
    <MaterialLibrary
      :show.sync="materialLibraryShow"
      :saveAdFileParam="saveAdFileParam"
      :adMaterialParams="adMaterialParams"
      uploadTypes="IMAGE"
      :currentAccount="currentAccount"
      @getSelectList="getSelectList"
    />
    <!-- 拖拽上传弹窗 -->
    <DragUploadDialog
      :limit="defaultParams.limit"
      :visible.sync="dragUploadVisible"
      @files-selected="handleDragFiles"
    />
  </div>
</template>

<script>
import getImageSize from '@adCommonComponent/utils/getImageSize.js';
import { getFileSize } from '@adCommonComponent/utils/getVideoMes.js';
import { uploadImg, uploadImgByUrl } from '@/api/google/create.js';
import GmUploadMaterialMix from '@adCommonComponent/components/upload/GmUploadMaterial';
import MaterialLibrary from '@/views/google/create/components/creatives/MaterialLibrary/index.vue';
import DragUploadDialog from '@/views/google/create/components/creatives/DragUploadDialog/index.vue';
import RetryImage from '@/views/google/create/components/creatives/RetryImage/index.vue';
import { getOptLogId, formatterName } from '../index';
export default {
  props: {
    value: { type: Array, default: () => [] },
    data: { type: Object, default: () => ({}) },
    currentAccount: {
      type: Object,
      default: () => ({}),
    },
    creative: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [GmUploadMaterialMix],
  components: { MaterialLibrary, DragUploadDialog, RetryImage },
  data() {
    return {
      //上传upload 参数
      defaultParams: {
        limit: 20,
        action: '#',
        accept: '.jpg,.png',
        multiple: true,
        'show-file-list': false,
        'list-type': 'picture-card',
      },
      materialLibraryShow: false,
      dragUploadVisible: false,
    };
  },
  computed: {
    imageList() {
      return this.value.map((v) => {
        v.id = v.id || v.uid;
        return v;
      });
    },
    userInfo() {
      return this.$store.state.user.userInfo.data;
    },
    saveAdFileParam() {
      console.log(this.data.promoteInfo);
      return {
        initiatorUid: this.userInfo.id,
        uid: this.userInfo.id,
        orgCode: this.userInfo.orgCode,
        saleId: this.data.promoteInfo?.sale?.saleId || this.value.promoteInfo?.sale?.saleId || 0, //创建|复制、批量编辑|
        langId: this.data.promoteInfo?.site?.langId || this.value.promoteInfo?.site?.langId || 0,
        proId: this.data.promoteInfo?.sale?.productId || this.value.promoteInfo?.sale?.productId || 0,
        adAccountId: this.currentAccount.id,
      };
    },
    adMaterialParams() {
      return {
        mediaType: 'IMAGE',
        platform: 'google',
        productId: this.data.promoteInfo?.sale?.productId || this.value.promoteInfo?.sale?.productId,
        aid: this.currentAccount.id,
        adid: this.creative?.adGroupAdId || '', //复制的时候没有,创建的时候没有
        lpu: this.creative?.finalUrl || '',
      };
    },
  },
  methods: {
    /**
     * 更新图片数组
     */
    updateValue(list) {
      console.log(list, 'eeeeee');
      list = list.slice(0, this.defaultParams.limit);
      this.$emit('update:value', list);
      this.$emit('change', list);
    },
    /**
     * 打开素材库
     */
    openLibrary() {
      this.$emit('openLibrary');
      this.materialLibraryShow = true;
    },
    /**
     * 打开拖拽上传弹窗
     */
    openDragUpload() {
      this.dragUploadVisible = true;
    },
    /**
     * 处理拖拽文件
     */
    handleDragFiles(files) {
      files.forEach((file) => {
        const fakeFile = {
          uid: Date.now() + Math.random(),
          raw: file,
          name: file.name,
          url: URL.createObjectURL(file),
        };
        this.onChange(fakeFile);
      });
    },
    /**
     * 删除图片
     */
    deleteItem(index) {
      this.imageList.splice(index, 1);
      this.updateValue(this.imageList);
    },
    /**
     * 图片比例误差范围
     * ratio :宽高比
     * errorRatio:误差范围
     */
    getErrorRatio(ratio, errorRatio) {
      return {
        min: ratio - ratio * errorRatio,
        max: ratio + ratio * errorRatio,
      };
    },
    /**
     * 校验图片大小
     * 横向图片 (1.91:1) 推荐尺寸：1200 x 628 最小尺寸要求：600 x 314
     * 方形图片 (1:1)推荐尺寸：1200 x 1200 最小尺寸要求：300 x 300
     * 纵向图片 (4:5)推荐尺寸：960 x 1200 最小尺寸要求：480 x 600
     */
    validateSize(width, height) {
      //图片宽高比
      const ratio = width / height;
      //   横向图片1.91/1 误差1%
      const transverseRatio = this.getErrorRatio(1.91, 0.01);
      const squareRatio = this.getErrorRatio(1, 0.01);
      const portraitRatio = this.getErrorRatio(4 / 5, 0.01);
      //  false 代表三个比例都不符合
      const isTransverse =
        ratio >= transverseRatio.min && ratio <= transverseRatio.max && width >= 600 && height >= 314;
      const isSquare = ratio >= squareRatio.min && ratio <= squareRatio.max && width >= 300 && height >= 300;
      const isPortrait = ratio >= portraitRatio.min && ratio <= portraitRatio.max && width >= 480 && height >= 600;
      return isTransverse || isSquare || isPortrait;
    },
    /**
     * 校验文件图片格式，大小，比例
     */
    validateImage(file, img) {
      return new Promise(async (resolve, reject) => {
        const raw = file?.raw || {};
        const imgTypes = ['image/png', 'image/jpg', 'image/jpeg'];
        if (img && !img.file_size) {
          img.file_size = await getFileSize(img.url);
        }
        const fileSize = img && img.file_size ? img.file_size / 1024 / 1024 : 0 || raw.size / 1024 / 1024;
        // 格式限制
        if (imgTypes.includes(raw.type) || img) {
          // 大小限制
          const isLt5MB = fileSize <= 5;
          if (!isLt5MB) {
            return reject('文件限制在5MB以内');
          }
          getImageSize(file?.url || img.url)
            .then((res) => {
              const { width, height } = res;
              if (!this.validateSize(width, height)) {
                return reject('请选择1.91:1或者1:1 或者4:5比例的图片,并且尺寸大于最小尺寸');
              }
              resolve();
            })
            .catch((err) => {
              console.log('err', err);
            });
        } else {
          reject('文件格式不正确');
        }
      });
    },
    /**
     * 触发change 事件
     */
    onChange(file) {
      if (this.imageList.length >= this.defaultParams.limit) return;
      const uid = file.uid;
      const index = this.imageList.findIndex((item) => item.uid == uid);
      let list = this.imageList;
      console.log(index, 'index,index,ibndex');
      if (index === -1) {
        console.log(file);
        file.mediaType = 'IMAGE';
        file.name = file.raw.name;
        file.status = 'uploading';
        file.process = 0;
        list.push(file);
        this.updateValue(list);
      }
      this.validateImage(file)
        .then(() => {
          if (index >= 0) {
            list[index] = file;
            this.updateValue(list);
          } else {
            this.$nextTick(() => {
              this.uploadFile(file);
            });
          }
        })
        .catch((err) => {
          // 使用 nextTick 确保在下一个事件循环中删除，避免竞态条件
          this.$nextTick(() => {
            const currentValue = [...this.value];
            const i = currentValue.findIndex((item) => item.uid == uid);
            if (i !== -1) {
              currentValue.splice(i, 1);
              this.updateValue(currentValue);
            }
          });
          this.$message.error(err);
        });
    },
    /**
     * 创建进度回调函数
     */
    createProgressCallback(uid) {
      return (event) => {
        const index = this.imageList.findIndex((item) => item.uid == uid);
        const list = this.imageList;
        let process = Math.round((event.loaded / event.total) * 100);

        if (index == -1) return;

        // 只有在非成功状态时才更新进度
        if (list[index].status !== 'success' && list[index].status !== 'fail') {
          this.$set(list, index, {
            ...list[index],
            process: process,
            status: 'uploading',
          });
        }
      };
    },
    /**
     * 上传图片到谷歌
     */
    async uploadImgToGoogle(data, accountId, uid) {
      try {
        const progressCallback = uid ? this.createProgressCallback(uid) : undefined;
        const res = await uploadImgByUrl(
          data,
          accountId,
          progressCallback ? { onUploadProgress: progressCallback } : {},
        );
        if (res.code == 0) {
          return res.data;
        } else {
          if (uid) {
            const list = this.imageList;
            const index = list.findIndex((item) => item.uid == uid);
            if (index !== -1) {
              this.$set(list, index, {
                ...list[index],
                status: 'fail',
                process: null,
              });
              this.updateValue([...list]);
            }
          }
          throw error;
        }
      } catch (error) {
        console.error('上传图片到谷歌失败:', error);
        // 如果有uid，更新对应文件状态为失败
        if (uid) {
          const list = this.imageList;
          const index = list.findIndex((item) => item.uid == uid);
          if (index !== -1) {
            this.$set(list, index, {
              ...list[index],
              status: 'fail',
              process: null,
            });
            this.updateValue([...list]);
          }
        }
        throw error;
      }
    },

    /**
     * 上传图片到服务器
     */
    async uploadFile(data) {
      const uid = data.uid;
      try {
        let resOss = await this.httpRequest(data.raw);
        console.log(resOss, 'resOss');
        const list = this.imageList;
        const index = list.findIndex((item) => item.uid == uid);
        if (index == -1) return;
        this.$set(list, index, {
          ...list[index],
          ...resOss,
          url: resOss.url,
          status: 'uploading',
          fileId: resOss.id,
          name: formatterName(resOss.name, resOss.md5, this.userInfo),
        });
        // this.updateValue(list);
        let res = await this.uploadImgToGoogle(
          {
            name: formatterName(resOss.name, resOss.md5, this.userInfo), //格式化素材名称
            height: resOss.high,
            with: resOss.width,
            url: resOss.url,
            fileId: resOss.id,
          },
          this.currentAccount.id,
          uid,
        );

        // 重新获取索引，因为异步操作过程中数组可能发生变化
        const currentList = this.imageList;
        const currentIndex = currentList.findIndex((item) => item.uid == uid);

        if (currentIndex > -1) {
          try {
            getOptLogId({
              adAccountId: this.currentAccount.id,
              mediaType: 'IMAGE',
              fileId: resOss.id,
              sourceType: 'UPLOAD',
            });
          } catch {}

          this.$set(currentList, currentIndex, {
            ...currentList[currentIndex],
            ...res,
            url: res.url,
            status: 'success',
            process: 100,
            fileId: res.id,
            name: formatterName(resOss.name, resOss.md5, this.userInfo),
          });
          this.updateValue([...currentList]);
        }
      } catch (error) {
        console.error('上传文件失败:', error);
        const list = this.imageList;
        const index = list.findIndex((item) => item.uid == uid);
        if (index !== -1) {
          this.$set(list, index, {
            ...list[index],
            status: 'fail',
            process: null,
          });
          this.updateValue(list);
        }
        this.$message.error(error.message || '上传失败，请重试');
      }
    },
    // 个人素材库选择
    getSelectList(list) {
      list.forEach(async (img) => {
        this.validateImage(null, img)
          .then(async () => {
            if (img.resourceName) {
              // 有 resourceName  选择是官方素材库，跳过上传
              //   list.push(img);
              console.log(list, 'listlistlist');
              this.updateValue([...this.value, { ...img, status: 'success', process: 100 }]);
            } else {
              // 选择的素材先赋值，显示在图片列表
              this.updateValue([...this.value, { ...img, status: 'uploading', process: 100 }]);
              try {
                let res = await this.uploadImgToGoogle(
                  { name: img.file_name, height: img.high, with: img.width, url: img.url, fileId: img.file_id },
                  this.currentAccount.id,
                );
                // 上传到谷歌后，重新赋值，修改状态，进度
                const list = this.imageList;
                let index = list.findIndex((v) => v.file_id == img.file_id);
                if (index !== -1) {
                  list[index] = {
                    ...list[index],
                    ...res,
                    status: 'success',
                    process: 100,
                    name: formatterName(img.file_name, img.md5_code, this.userInfo),
                  };
                  this.updateValue([...list]);
                }
                try {
                  getOptLogId({
                    adAccountId: this.currentAccount.id,
                    mediaType: 'IMAGE',
                    fileId: img.file_id,
                    sourceType: 'SELF_LIB',
                  });
                } catch {}
              } catch (error) {
                console.error('素材库图片上传到谷歌失败:', error);
                // 上传失败时更新状态
                const list = this.imageList;
                let index = list.findIndex((v) => v.file_id == img.file_id);
                if (index !== -1) {
                  list[index] = {
                    ...list[index],
                    status: 'fail',
                    process: null,
                  };
                  this.updateValue([...list]);
                }
                this.$message.error(error.message || '素材上传失败，请重试');
              }
            }
          })
          .catch((err) => {
            this.$message.close();
            this.$message.error(err);
          });
      });
    },
  },
};
</script>
<style lang="scss">
.uploadGoogleImg {
  .el-upload--picture-card {
    width: 160px;
    height: 240px;
  }
}
</style>
